{
  "destinationSearch": {
    "calendarButton": "#View dates#"
  },
  "timetable": {
    "panel": {
      "title": "Timetable",
      "departure": "Departure",
      "return": "Return",
      "bookFlights": "Book flights"
    },
    "flightList": {
      "selectDepartureDate": "Select a departure date to see the timetable.",
      "selectReturnDate": "Select a return date to see the timetable."
    }
  },
  "bookingSearch": {
    "errors": {
      "noResults": {
        "noFlightsFound": "Sorry, we couldn't find any flights",
        "noFlightsAvailable": "Sorry, there are no flights available"
      },
      "actions": {
        "reloadPage": "Reload this page",
        "toFrontPage": "Go to front page"
      }
    }
  },
  "serviceForms": {
    "refundsCompensations": {
      "continue": "Continue",
      "newCase": "Create new case",
      "viewCase": "View existing cases",
      "infoAccordion": [
        {
          "title": "Eligible refund and compensation cases",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Documents needed for submitting a claim",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Gift voucher benefits",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        }
      ]
    },
    "specialAssistanceWizard": {
      "infoAccordion": [
        {
          "title": "Accordion title 1",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Accordion title 2",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Accordion title 3",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        }
      ]
    },
    "fields": {
      "preorderBagNumber": {
        "label": " Preorder Bag Number",
        "placeholder": "E.g. 6291015"
      }
    }
  },
  "ticketSelection": {
    "travelClassAlternative": "We could not find any flights with your selected travel class, so here are some other alternatives."
  },
  "indiaRedirectNotification": "Hi! We redirected you to our international site from the Indian country site, which is temporarily closed for enhancements. You can book flights and use our services on this site as you would on the Indian one. We are sorry for any inconvenience.",
  "ondMarketing": {
    "flightsFrom": "Flights from {origin}",
    "exploreMoreHeading": "Explore more flights and destinations"
  }
}
